var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0136 3.36129C10.8184 3.16603 10.5018 3.16603 10.3065 3.36129L4.88245 8.78537L1.6934 5.59632C1.49814 5.40106 1.18155 5.40106 0.98629 5.59632C0.791028 5.79158 0.791028 6.10817 0.98629 6.30343L4.52182 9.83896C4.62418 9.94132 4.75987 9.99002 4.89394 9.98507C5.02053 9.98403 5.14681 9.93522 5.24339 9.83864L11.0136 4.0684C11.2089 3.87313 11.2089 3.55655 11.0136 3.36129Z",
    fill: "#39BA6D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5a1444aaecbf1f6cdd125a60bdab4893.svg";
export { ForwardRef as ReactComponent };